<div *ngIf="isReady">
    <div class="mb-3 p-3 rounded border bg-white shadow-sm">
        <div [formGroup]="profileForm">

            <h5 class="mb-3">Registration Information</h5>

            <div class="row">
                <div class="col-6 pb-2">
                    <label id="investor-register-profile-field-company-text" for="investor-register-profile-field-company-input">Company Name <span class="text-danger">*</span></label>
                    <input 
                        id="investor-register-profile-field-company-input" 
                        formControlName="companyName" 
                        [typeahead]="companies" 
                        [adaptivePosition]="true"
                        [typeaheadOptionsLimit]="10" 
                        placeholder="Please select your company name or type it manually if not listed."
                        typeaheadOptionField="companyName" 
                        class="form-control"
                        englishInput>
                    <small id="investor-register-profile-field-company-required-error-text" class="invalid-input" *ngIf="f.companyName.touched && f.companyName.invalid">
                        Company is required
                    </small>
                </div>

                <div class="col-6 pb-2"></div>

                <div class="col-6 pb-2 mt-2">
                    <div id="investor-register-profile-field-name-text" class="pb-1">Name <span class="text-danger">(No Title Required)*</span></div>
                    <input 
                        id="investor-register-profile-field-name-input" 
                        type="text" class="form-control" 
                        formControlName="firstName"
                        autocomplete="new-firstName" 
                        required 
                        normalizeName>
                    <small id="investor-register-profile-field-name-required-error-text" class="invalid-input" *ngIf="f.firstName.touched && f.firstName.invalid">
                        Name is required
                    </small>
                </div>

                <div class="col-6 pb-2 mt-2">
                    <div id="investor-register-profile-field-surname-text" class="pb-1">Surname <span class="text-danger">*</span></div>
                    <input 
                        id="investor-register-profile-field-surname-input" 
                        type="text" class="form-control" 
                        formControlName="lastName"
                        autocomplete="new-lastName" 
                        required 
                        normalizeName>
                    <small id="investor-register-profile-field-surname-required-error-text" class="invalid-input" *ngIf="f.lastName.touched && f.lastName.invalid">
                        Surname is required
                    </small>
                </div>

                <div class="col-6 pb-2 mt-2">
                    <div id="investor-register-profile-field-email-text" class="pb-1">Email <span class="text-danger">*</span></div>
                    <input 
                        id="investor-register-profile-field-email-input" 
                        type="email" 
                        class="form-control" 
                        formControlName="email"
                        placeholder="example@xxx.or.th"
                        (blur)="onBlurCheckEmailDuplicate('email')"
                        required
                        englishInput
                        readonly>
                    <small id="investor-register-profile-field-duplicated-error-email-text" *ngIf="f.email.errors?.duplicateEmail" class="text-danger">
                        Registrant and Assistant email must not be the same
                    </small>
                    <small id="investor-register-profile-field-already-used-error-email-text" *ngIf="f.email.errors?.alreadyUsed" class="text-danger">
                        Email is already registered
                    </small>
                    <p class="invalid-input" *ngIf="f.email.touched && f.email.invalid">
                        <small id="investor-register-profile-field-required-error-email-text" *ngIf="f.email.errors?.required" class="text-danger">
                            Email is required
                        </small>
                        <small id="investor-register-profile-field-pattern-error-email-text" *ngIf="f.email.errors?.email" class="text-danger">
                            Please provide a valid email address
                        </small>
                    </p>
                </div>

                <div class="col-3 pb-2 mt-2">
                    <div id="investor-register-profile-field-mobile-text" class="pb-1">Mobile Number <span class="text-danger">*</span></div>
                    <ngx-intl-tel-input
                        [cssClass]="'form-control intl-tel-input'" 
                        [preferredCountries]="preferredCountries"
                        [searchCountryFlag]="true"
                        [searchCountryField]="searchCountryField"
                        [phoneValidation]="true" 
                        [inputId]="'investor-register-profile-field-mobile-input'" 
                        formControlName="mobileNumber" 
                        [enablePlaceholder]="true"
                        required
                        mobile>
                    </ngx-intl-tel-input>
                    <small id="investor-register-profile-field-mobile-pattern-error-text" class="text-danger" *ngIf="f.mobileNumber.touched && !!f.mobileNumber.errors?.validatePhoneNumber">
                        Mobile is invalid pattern
                    </small>
                    <div class="text-danger" *ngIf="f.mobileNumber.touched && f.mobileNumber.invalid">
                        <small id="investor-register-profile-field-mobile-required-error-text" *ngIf="f.mobileNumber.errors?.required">
                            Mobile is required
                        </small>
                    </div>
                </div>

                <div class="col-3 pb-2 mt-2">
                    <div id="investor-register-profile-field-ext-number-text" class="pb-1">Ext. Number</div>
                    <input
                        id="investor-register-profile-field-ext-number-input" 
                        type="text" 
                        class="form-control" 
                        formControlName="extNumber"
                        englishInput>
                </div>

                <div class="col-6 pb-2 mt-2">
                    <div id="investor-register-profile-field-job-text" class="pb-1">Job Title <span class="text-danger">*</span></div>
                    <input 
                        id="investor-register-profile-field-job-input" 
                        type="text" class="form-control" 
                        formControlName="jobTitle"
                        required
                        englishInput>
                    <small id="investor-register-profile-field-job-required-error-text" class="invalid-input" *ngIf="f.jobTitle.touched && f.jobTitle.invalid">
                        Job title is required
                    </small>
                </div>

                <div class="col-6 pb-2 mt-2">
                    <div id="investor-register-profile-field-department-text" for="investor-register-profile-field-department-input" class="pb-1">Department <span class="text-danger">*</span></div>
                    <input 
                        id="investor-register-profile-field-department-input" 
                        type="text" 
                        class="form-control" 
                        formControlName="department"
                        required
                        englishInput>
                    <small id="investor-register-profile-field-department-required-error-text" class="invalid-input" *ngIf="f.department.touched && f.department.invalid">
                        Department is required
                    </small>
                </div>

                <div class="col-6 pb-2 mt-2">
                    <div id="investor-register-profile-field-country-text" class="pb-1">Country <span class="text-danger">*</span></div>
                    <ng-select 
                        id="investor-register-profile-field-country-selector" 
                        name="country" 
                        id="country" 
                        placeholder="Please Select Country"
                        formControlName="countryId" 
                        excludeTh>
                    <ng-option *ngFor="let country of countries" [value]="country.id">{{country.name}}</ng-option>
                    </ng-select>
                    <small id="investor-register-profile-field-country-required-error-text" class="invalid-input" *ngIf="f.countryId.touched && f.countryId.invalid">
                        Country is required
                    </small>
                </div>

                <div class="col-3 pb-2 mt-2" *ngIf="eventInfoWithConsent | shouldShowInstitutionalInvestorType">
                    <div id="investor-register-profile-field-institutional-text" class="pb-1">Types of Institutional Investors <span class="text-danger">*</span></div>
                    <ng-select 
                        id="investor-register-profile-field-institutional-selector" 
                        name="institutional" 
                        id="institutional" 
                        placeholder="Please Select"
                        formControlName="institutionalInvestorTypeId" 
                        excludeTh>
                    <ng-option *ngFor="let type of institutionalInvestorTypes" [value]="type.id">{{type.typeName}}</ng-option>
                    </ng-select>
                    <small id="investor-register-profile-field-institutional-required-error-text" class="invalid-input" *ngIf="f.institutionalInvestorTypeId.touched && f.institutionalInvestorTypeId.invalid">
                        Types of Institutional Investors is required
                    </small>
                </div>
                
                <div class="col-3 pb-2 mt-2" *ngIf="isOtherInstitutionalInvestorTypeSelected() && (eventInfoWithConsent | shouldShowInstitutionalInvestorType)">
                    <div id="investor-register-profile-field-other-institutional-text" class="pb-1">Specific <span class="text-danger">*</span></div>
                    <input 
                        id="investor-register-profile-field-other-institutional-input" 
                        type="text" 
                        class="form-control" 
                        placeholder="Specific"
                        formControlName="otherInstitutionalInvestorType"
                        englishInput>
                    <small id="investor-register-profile-field-other-institutional-required-error-text" class="invalid-input" *ngIf="f.otherInstitutionalInvestorType.touched && f.otherInstitutionalInvestorType.invalid">
                        Specific is required
                    </small>
                </div>
            </div>

        </div>
    </div>
</div>